import { apiClient } from './client';

export const EVIDENCE_STAGE_IDS = [
  'LOADING', 'SEALING', 'DEPARTURE', 'CHECKPOINT', 'INSPECTION', 'DELIVERY', 'INCIDENT',
] as const;
export type EvidenceStageId = typeof EVIDENCE_STAGE_IDS[number];

export interface EvidenceShare {
  shareId: string;
  label: string | null;
  stages: EvidenceStageId[] | null;
  createdAt: string;
  expiresAt: string;
  revokedAt: string | null;
  active: boolean;
}

export interface CreatedShare {
  shareId: string;
  token: string;
  expiresAt: string;
}

export interface SharedEvidenceItem {
  evidenceId: string;
  stage: string;
  kind: "PHOTO" | "VIDEO";
  capturedAt: string;
  placeName?: string;
  note?: string;
  url: string;
}

export interface SharedEvidenceResponse {
  label: string | null;
  expiresAt: string;
  evidence: SharedEvidenceItem[];
}

const base = (shipmentId: string) => `/api/transport/shipments/${shipmentId}/evidence/share`;

export const fetchEvidenceShares = async (shipmentId: string): Promise<EvidenceShare[]> =>
  (await apiClient.get(base(shipmentId))).data;

export const createEvidenceShare = async (
  shipmentId: string,
  input: { label?: string; days: number; stages?: EvidenceStageId[] },
): Promise<CreatedShare> => (await apiClient.post(base(shipmentId), input)).data;

export const revokeEvidenceShare = async (shipmentId: string, shareId: string): Promise<void> => {
  await apiClient.delete(`${base(shipmentId)}/${shareId}`);
};

/** Público: no requiere sesión ni empresa; el token va en la URL. */
export const fetchSharedEvidence = async (token: string): Promise<SharedEvidenceResponse> =>
  (await apiClient.get('/api/shared/shipment-evidence', { params: { token } })).data;
